
import { importSync as i, macroCondition, getGlobalConfig } from '@embroider/macros';
let w = window;
let d = w.define;


i("./-embroider-implicit-modules.js");

d("dashboard/app", function(){ return i("dashboard/app.ts");});
d("dashboard/authenticators/bling", function(){ return i("dashboard/authenticators/bling.ts");});
d("dashboard/authenticators/feide", function(){ return i("dashboard/authenticators/feide.ts");});
d("dashboard/authenticators/google", function(){ return i("dashboard/authenticators/google.ts");});
d("dashboard/authenticators/microsoft", function(){ return i("dashboard/authenticators/microsoft.ts");});
d("dashboard/authenticators/oauth2", function(){ return i("dashboard/authenticators/oauth2.ts");});
d("dashboard/authenticators/showbie", function(){ return i("dashboard/authenticators/showbie.ts");});
d("dashboard/breakpoints", function(){ return i("dashboard/breakpoints.js");});
d("dashboard/config/environment", function(){ return i("dashboard/config/environment.js");});
d("dashboard/constants", function(){ return i("dashboard/constants.ts");});
d("dashboard/deprecation-workflow", function(){ return i("dashboard/deprecation-workflow.js");});
d("dashboard/ember-intl-formats", function(){ return i("dashboard/ember-intl-formats.ts");});
d("dashboard/gql/mutations/activate.gql", function(){ return i("dashboard/gql/mutations/activate.gql.js");});
d("dashboard/gql/mutations/assign-courses-to-teacher.gql", function(){ return i("dashboard/gql/mutations/assign-courses-to-teacher.gql.js");});
d("dashboard/gql/mutations/bulkInviteTeacherToSchool.gql", function(){ return i("dashboard/gql/mutations/bulkInviteTeacherToSchool.gql.js");});
d("dashboard/gql/mutations/connect-sync-school.gql", function(){ return i("dashboard/gql/mutations/connect-sync-school.gql.js");});
d("dashboard/gql/mutations/deactivate.gql", function(){ return i("dashboard/gql/mutations/deactivate.gql.js");});
d("dashboard/gql/mutations/delete-user.gql", function(){ return i("dashboard/gql/mutations/delete-user.gql.js");});
d("dashboard/gql/mutations/disable-sync.gql", function(){ return i("dashboard/gql/mutations/disable-sync.gql.js");});
d("dashboard/gql/mutations/disconnect-sync-school.gql", function(){ return i("dashboard/gql/mutations/disconnect-sync-school.gql.js");});
d("dashboard/gql/mutations/enable-sync.gql", function(){ return i("dashboard/gql/mutations/enable-sync.gql.js");});
d("dashboard/gql/mutations/mark-sync-users-as-reviewed.gql", function(){ return i("dashboard/gql/mutations/mark-sync-users-as-reviewed.gql.js");});
d("dashboard/gql/mutations/remove-student-avatar.gql", function(){ return i("dashboard/gql/mutations/remove-student-avatar.gql.js");});
d("dashboard/gql/mutations/resend-activation-emails.gql", function(){ return i("dashboard/gql/mutations/resend-activation-emails.gql.js");});
d("dashboard/gql/mutations/resend-email-confirmation.gql", function(){ return i("dashboard/gql/mutations/resend-email-confirmation.gql.js");});
d("dashboard/gql/mutations/reset-password.gql", function(){ return i("dashboard/gql/mutations/reset-password.gql.js");});
d("dashboard/gql/mutations/set-sso-student-password.gql", function(){ return i("dashboard/gql/mutations/set-sso-student-password.gql.js");});
d("dashboard/gql/mutations/set-student-password.gql", function(){ return i("dashboard/gql/mutations/set-student-password.gql.js");});
d("dashboard/gql/mutations/start-school-sync.gql", function(){ return i("dashboard/gql/mutations/start-school-sync.gql.js");});
d("dashboard/gql/mutations/start-sign-in-qr-export-job.gql", function(){ return i("dashboard/gql/mutations/start-sign-in-qr-export-job.gql.js");});
d("dashboard/gql/mutations/teacherBulkAction.gql", function(){ return i("dashboard/gql/mutations/teacherBulkAction.gql.js");});
d("dashboard/gql/mutations/unsync-user.gql", function(){ return i("dashboard/gql/mutations/unsync-user.gql.js");});
d("dashboard/gql/mutations/update-purchaser-settings.gql", function(){ return i("dashboard/gql/mutations/update-purchaser-settings.gql.js");});
d("dashboard/gql/mutations/update-student.gql", function(){ return i("dashboard/gql/mutations/update-student.gql.js");});
d("dashboard/gql/queries/administrators.gql", function(){ return i("dashboard/gql/queries/administrators.gql.js");});
d("dashboard/gql/queries/analytics-embed.gql", function(){ return i("dashboard/gql/queries/analytics-embed.gql.js");});
d("dashboard/gql/queries/auditors.gql", function(){ return i("dashboard/gql/queries/auditors.gql.js");});
d("dashboard/gql/queries/courses.gql", function(){ return i("dashboard/gql/queries/courses.gql.js");});
d("dashboard/gql/queries/mis-handout.gql", function(){ return i("dashboard/gql/queries/mis-handout.gql.js");});
d("dashboard/gql/queries/plan.gql", function(){ return i("dashboard/gql/queries/plan.gql.js");});
d("dashboard/gql/queries/purchaser-settings.gql", function(){ return i("dashboard/gql/queries/purchaser-settings.gql.js");});
d("dashboard/gql/queries/purchaser-with-sync-details.gql", function(){ return i("dashboard/gql/queries/purchaser-with-sync-details.gql.js");});
d("dashboard/gql/queries/purchaser-year-groups.gql", function(){ return i("dashboard/gql/queries/purchaser-year-groups.gql.js");});
d("dashboard/gql/queries/purchaser.gql", function(){ return i("dashboard/gql/queries/purchaser.gql.js");});
d("dashboard/gql/queries/school-sync-progress.gql", function(){ return i("dashboard/gql/queries/school-sync-progress.gql.js");});
d("dashboard/gql/queries/school-sync-stats.gql", function(){ return i("dashboard/gql/queries/school-sync-stats.gql.js");});
d("dashboard/gql/queries/school-sync-year-groups.gql", function(){ return i("dashboard/gql/queries/school-sync-year-groups.gql.js");});
d("dashboard/gql/queries/sign-in-qr-export-job-status.gql", function(){ return i("dashboard/gql/queries/sign-in-qr-export-job-status.gql.js");});
d("dashboard/gql/queries/student.gql", function(){ return i("dashboard/gql/queries/student.gql.js");});
d("dashboard/gql/queries/students.gql", function(){ return i("dashboard/gql/queries/students.gql.js");});
d("dashboard/gql/queries/sync-users-errored.gql", function(){ return i("dashboard/gql/queries/sync-users-errored.gql.js");});
d("dashboard/gql/queries/sync-users-id-only.gql", function(){ return i("dashboard/gql/queries/sync-users-id-only.gql.js");});
d("dashboard/gql/queries/sync-users-with-system-errors.gql", function(){ return i("dashboard/gql/queries/sync-users-with-system-errors.gql.js");});
d("dashboard/gql/queries/sync-users.gql", function(){ return i("dashboard/gql/queries/sync-users.gql.js");});
d("dashboard/gql/queries/teacher.gql", function(){ return i("dashboard/gql/queries/teacher.gql.js");});
d("dashboard/gql/queries/teachers.gql", function(){ return i("dashboard/gql/queries/teachers.gql.js");});
d("dashboard/gql/queries/user.gql", function(){ return i("dashboard/gql/queries/user.gql.js");});
d("dashboard/gql/types.gql", function(){ return i("dashboard/gql/types.gql.js");});
d("dashboard/router", function(){ return i("dashboard/router.js");});
d("dashboard/services/-apollo", function(){ return i("dashboard/services/-apollo.ts");});
d("dashboard/services/-session", function(){ return i("dashboard/services/-session.ts");});
d("dashboard/services/analytics", function(){ return i("dashboard/services/analytics.ts");});
d("dashboard/services/apollo", function(){ return i("dashboard/services/apollo.js");});
d("dashboard/services/current-user", function(){ return i("dashboard/services/current-user.ts");});
d("dashboard/services/export-student-qr-codes", function(){ return i("dashboard/services/export-student-qr-codes.ts");});
d("dashboard/services/google-client", function(){ return i("dashboard/services/google-client.ts");});
d("dashboard/services/http-analytics", function(){ return i("dashboard/services/http-analytics.ts");});
d("dashboard/services/notify", function(){ return i("dashboard/services/notify.ts");});
d("dashboard/services/paywall", function(){ return i("dashboard/services/paywall.ts");});
d("dashboard/services/session", function(){ return i("dashboard/services/session.js");});
d("dashboard/services/toast", function(){ return i("dashboard/services/toast.ts");});
d("dashboard/services/typeform-manager", function(){ return i("dashboard/services/typeform-manager.ts");});
d("dashboard/session-stores/application", function(){ return i("dashboard/session-stores/application.ts");});
d("dashboard/shoelace", function(){ return i("dashboard/shoelace.js");});
d("dashboard/snippets", function(){ return i("dashboard/snippets.js");});
d("dashboard/types/index", function(){ return i("dashboard/types/index.ts");});
d("dashboard/types/looker-analytics", function(){ return i("dashboard/types/looker-analytics.ts");});
d("dashboard/types/shoelace-extras", function(){ return i("dashboard/types/shoelace-extras.ts");});
d("dashboard/utils/account-review-step", function(){ return i("dashboard/utils/account-review-step.ts");});
d("dashboard/utils/capture-graphql-error", function(){ return i("dashboard/utils/capture-graphql-error.ts");});
d("dashboard/utils/convert-to-csv", function(){ return i("dashboard/utils/convert-to-csv.ts");});
d("dashboard/utils/cycle-sort-options", function(){ return i("dashboard/utils/cycle-sort-options.ts");});
d("dashboard/utils/errors", function(){ return i("dashboard/utils/errors.ts");});
d("dashboard/utils/index", function(){ return i("dashboard/utils/index.ts");});
d("dashboard/utils/list-filter", function(){ return i("dashboard/utils/list-filter.ts");});
d("dashboard/utils/persist-reboot-error", function(){ return i("dashboard/utils/persist-reboot-error.ts");});
d("dashboard/utils/preferred-page-length", function(){ return i("dashboard/utils/preferred-page-length.ts");});
d("dashboard/utils/sort-purchasers", function(){ return i("dashboard/utils/sort-purchasers.ts");});
d("dashboard/utils/sort-year-groups", function(){ return i("dashboard/utils/sort-year-groups.ts");});
d("dashboard/utils/underscoreize", function(){ return i("dashboard/utils/underscoreize.ts");});
d("dashboard/services/features", function(){ return i("dashboard/services/features.js");});
d("dashboard/services/keyboard", function(){ return i("dashboard/services/keyboard.js");});
d("dashboard/services/media", function(){ return i("dashboard/services/media.js");});
d("dashboard/services/page-title", function(){ return i("dashboard/services/page-title.js");});
d("dashboard/services/shiki", function(){ return i("dashboard/services/shiki.js");});
d("dashboard/services/cookies", function(){ return i("dashboard/services/cookies.js");});
d("dashboard/initializers/ember-simple-auth", function(){ return i("dashboard/initializers/ember-simple-auth.js");});
d("dashboard/services/-portal", function(){ return i("dashboard/services/-portal.js");});
d("dashboard/instance-initializers/sentry-performance", function(){ return i("dashboard/instance-initializers/sentry-performance.js");});
d("dashboard/initializers/app-version", function(){ return i("dashboard/initializers/app-version.js");});
d("dashboard/services/intl", function(){ return i("dashboard/services/intl.js");});
d("dashboard/templates/application", function(){ return i("dashboard/templates/application.hbs");});
d("dashboard/controllers/application", function(){ return i("dashboard/controllers/application.ts");});
d("dashboard/routes/application", function(){ return i("dashboard/routes/application.ts");});
d("dashboard/templates/login", function(){ return i("dashboard/templates/login.hbs");});
d("dashboard/controllers/login", function(){ return i("dashboard/controllers/login.ts");});
d("dashboard/routes/login", function(){ return i("dashboard/routes/login.ts");});
d("dashboard/routes/bling-mode", function(){ return i("dashboard/routes/bling-mode.ts");});
d("dashboard/routes/classes", function(){ return i("dashboard/routes/classes.ts");});
d("dashboard/routes/not-found", function(){ return i("dashboard/routes/not-found.ts");});
d("dashboard/routes/settings", function(){ return i("dashboard/routes/settings.ts");});
d("dashboard/routes/students", function(){ return i("dashboard/routes/students.ts");});
d("dashboard/routes/teachers", function(){ return i("dashboard/routes/teachers.ts");});



w._embroiderRouteBundles_ = [
  {
    names: ["dashboard.account.analytics.embed"],
    load: function() {
      return import("dashboard/assets/_route_/dashboard.account.analytics.embed.js");
    }
  },
  {
    names: ["dashboard.account.analytics.organisation.embed"],
    load: function() {
      return import("dashboard/assets/_route_/dashboard.account.analytics.organisation.embed.js");
    }
  },
  {
    names: ["dashboard.account.analytics.organisation.index"],
    load: function() {
      return import("dashboard/assets/_route_/dashboard.account.analytics.organisation.index.js");
    }
  },
  {
    names: ["dashboard.account.analytics.organisation"],
    load: function() {
      return import("dashboard/assets/_route_/dashboard.account.analytics.organisation.js");
    }
  },
  {
    names: ["dashboard.account.analytics.teachers.embed"],
    load: function() {
      return import("dashboard/assets/_route_/dashboard.account.analytics.teachers.embed.js");
    }
  },
  {
    names: ["dashboard.account.analytics.teachers.index"],
    load: function() {
      return import("dashboard/assets/_route_/dashboard.account.analytics.teachers.index.js");
    }
  },
  {
    names: ["dashboard.account.analytics.teachers"],
    load: function() {
      return import("dashboard/assets/_route_/dashboard.account.analytics.teachers.js");
    }
  },
  {
    names: ["dashboard.account.analytics.index"],
    load: function() {
      return import("dashboard/assets/_route_/dashboard.account.analytics.index.js");
    }
  },
  {
    names: ["dashboard.account.analytics"],
    load: function() {
      return import("dashboard/assets/_route_/dashboard.account.analytics.js");
    }
  },
  {
    names: ["dashboard.account.classes"],
    load: function() {
      return import("dashboard/assets/_route_/dashboard.account.classes.js");
    }
  },
  {
    names: ["dashboard.account.index"],
    load: function() {
      return import("dashboard/assets/_route_/dashboard.account.index.js");
    }
  },
  {
    names: ["dashboard.account.settings.account-review-students"],
    load: function() {
      return import("dashboard/assets/_route_/dashboard.account.settings.account-review-students.js");
    }
  },
  {
    names: ["dashboard.account.settings.account-review-teachers"],
    load: function() {
      return import("dashboard/assets/_route_/dashboard.account.settings.account-review-teachers.js");
    }
  },
  {
    names: ["dashboard.account.settings.account-review"],
    load: function() {
      return import("dashboard/assets/_route_/dashboard.account.settings.account-review.js");
    }
  },
  {
    names: ["dashboard.account.settings.integration"],
    load: function() {
      return import("dashboard/assets/_route_/dashboard.account.settings.integration.js");
    }
  },
  {
    names: ["dashboard.account.settings.admin-accounts"],
    load: function() {
      return import("dashboard/assets/_route_/dashboard.account.settings.admin-accounts.js");
    }
  },
  {
    names: ["dashboard.account.settings.index"],
    load: function() {
      return import("dashboard/assets/_route_/dashboard.account.settings.index.js");
    }
  },
  {
    names: ["dashboard.account.settings.purchaser-settings"],
    load: function() {
      return import("dashboard/assets/_route_/dashboard.account.settings.purchaser-settings.js");
    }
  },
  {
    names: ["dashboard.account.settings"],
    load: function() {
      return import("dashboard/assets/_route_/dashboard.account.settings.js");
    }
  },
  {
    names: ["dashboard.account.student.courses"],
    load: function() {
      return import("dashboard/assets/_route_/dashboard.account.student.courses.js");
    }
  },
  {
    names: ["dashboard.account.student.index"],
    load: function() {
      return import("dashboard/assets/_route_/dashboard.account.student.index.js");
    }
  },
  {
    names: ["dashboard.account.student"],
    load: function() {
      return import("dashboard/assets/_route_/dashboard.account.student.js");
    }
  },
  {
    names: ["dashboard.account.students"],
    load: function() {
      return import("dashboard/assets/_route_/dashboard.account.students.js");
    }
  },
  {
    names: ["dashboard.account.teacher.courses"],
    load: function() {
      return import("dashboard/assets/_route_/dashboard.account.teacher.courses.js");
    }
  },
  {
    names: ["dashboard.account.teacher.index"],
    load: function() {
      return import("dashboard/assets/_route_/dashboard.account.teacher.index.js");
    }
  },
  {
    names: ["dashboard.account.teacher"],
    load: function() {
      return import("dashboard/assets/_route_/dashboard.account.teacher.js");
    }
  },
  {
    names: ["dashboard.account.teachers"],
    load: function() {
      return import("dashboard/assets/_route_/dashboard.account.teachers.js");
    }
  },
  {
    names: ["dashboard.account.classes-district"],
    load: function() {
      return import("dashboard/assets/_route_/dashboard.account.classes-district.js");
    }
  },
  {
    names: ["dashboard.account.pending"],
    load: function() {
      return import("dashboard/assets/_route_/dashboard.account.pending.js");
    }
  },
  {
    names: ["dashboard.account.students-district"],
    load: function() {
      return import("dashboard/assets/_route_/dashboard.account.students-district.js");
    }
  },
  {
    names: ["dashboard.account"],
    load: function() {
      return import("dashboard/assets/_route_/dashboard.account.js");
    }
  },
  {
    names: ["dashboard.index"],
    load: function() {
      return import("dashboard/assets/_route_/dashboard.index.js");
    }
  },
  {
    names: ["dashboard"],
    load: function() {
      return import("dashboard/assets/_route_/dashboard.js");
    }
  },
  {
    names: ["lbx.avatar"],
    load: function() {
      return import("dashboard/assets/_route_/lbx.avatar.js");
    }
  },
  {
    names: ["lbx.badge"],
    load: function() {
      return import("dashboard/assets/_route_/lbx.badge.js");
    }
  },
  {
    names: ["lbx.banner-alert"],
    load: function() {
      return import("dashboard/assets/_route_/lbx.banner-alert.js");
    }
  },
  {
    names: ["lbx.button"],
    load: function() {
      return import("dashboard/assets/_route_/lbx.button.js");
    }
  },
  {
    names: ["lbx.dialog"],
    load: function() {
      return import("dashboard/assets/_route_/lbx.dialog.js");
    }
  },
  {
    names: ["lbx.index"],
    load: function() {
      return import("dashboard/assets/_route_/lbx.index.js");
    }
  },
  {
    names: ["lbx.input"],
    load: function() {
      return import("dashboard/assets/_route_/lbx.input.js");
    }
  },
  {
    names: ["lbx.menu"],
    load: function() {
      return import("dashboard/assets/_route_/lbx.menu.js");
    }
  },
  {
    names: ["lbx.select"],
    load: function() {
      return import("dashboard/assets/_route_/lbx.select.js");
    }
  },
  {
    names: ["lbx.switch"],
    load: function() {
      return import("dashboard/assets/_route_/lbx.switch.js");
    }
  },
  {
    names: ["lbx.toast"],
    load: function() {
      return import("dashboard/assets/_route_/lbx.toast.js");
    }
  },
  {
    names: ["lbx"],
    load: function() {
      return import("dashboard/assets/_route_/lbx.js");
    }
  },
  {
    names: ["oauth.feide.redirect"],
    load: function() {
      return import("dashboard/assets/_route_/oauth.feide.redirect.js");
    }
  },
]


if (!runningTests) {
  i("../app").default.create({"analytics":{"enabled":true,"amplitudeApiKey":"6692c94018bc29237cc093097ebf0571"},"authentication":{"enabled":false,"url":"https://adminqa.showbie.com/core/v5","showbie":{"clientApiKey":"ADMINDASHS62386a9456842d1606f586ed2468701684"},"google":{"clientId":"30795789325-js912iundn1fdectk4hq9eufuce32efq.apps.googleusercontent.com"},"microsoft":{"clientId":"55f15c80-8fce-4386-8c26-a99ff2b9c82f","redirectUri":"https://adminqa.showbie.com"},"feide":{"authority":"https://auth.dataporten.no","clientId":"62b1234e-0042-49f0-b9b6-5fff5be8add7","redirectPath":"oauth/feide/redirect"}},"defaultAvatarUrl":"https://d3cz40e5fkp2js.cloudfront.net/images/shim.png","legacyDashboardUrl":"https://dashboardqa.showbie.com","pagination":{"defaultPageLength":"20","pageLengthOptions":["20","60"]},"tooltipHideDelay":3000,"notifyHideDelay":4000,"mirage":{"enabled":false},"name":"dashboard","version":"1.6.0+401a6ad4"});
}

